import md5 from "../md5.js";
import { checkValidator } from "../validator";
import Client from "../request";
const wxAppId = process.env.Wechat_MiniAppId;

/**
 * 账户密码登录器
 */
export class IdPasswordLoginController {
  loginId = "";
  password = "";

  errors = {};

  el = null

  constructor(
    el
  ) {
    this.el = el
  }

  async validate() {
    const model = this.toJSON();
    const errors = await checkValidator(model, {
      loginId: [{ type: "string", required: true, message: "请填写登录账户" }],
      password: [{ type: "string", required: true, message: "请填写登录密码" }],
    });
    if (errors) {
      this.errors = errors;
      throw new Error("登录信息填写错误");
    }
  }

  async login() {
    this.el.loading = true
    try {
      await this.validate()
      let { data } = await Client.post('/mm/user/v2/login', JSON.stringify(this.toJSON()))
      this.el.afterLogin(data)
    } catch (error) {
      this.el.errorMessage(error.message)
    }
    this.el.loading = false
  }

  toJSON() {
    return {
      loginId: this.loginId,
      password: md5(this.password),
    };
  }

  destroy() {
    this.loginId = "";
    this.password = "";
    this.errors = {};
  }
}

export class QrcodeLoginController {
  qrcode = "";
  key = ""
  scaning = false
  qrcodeType = 0

  errors = {}

  abort = () => { }

  el = null

  constructor(
    el
  ) {
    this.el = el
    this.getQrcode()
  }

  async getQrcode() {
    let req = Client.post(`/wx/mp/${wxAppId}/createLoginQrcode`)
    this.abort = req.abort
    let { data: { image, key } } = await req;
    this.qrcode = image
    this.key = key
    this.qrcodeType = 0
    this.refresh()
  }

  async refresh() {
    let req = Client.get(`/wx/mp/${wxAppId}/getLoginQrcodeStatus`, {
      key: this.key,
    }, { noMessage: true })
    this.abort = req.abort
    let { data } = await req
    if (data.qrcodeType === 0) {
      this.refresh()
    } else if (data.qrcodeType === 1) {
      this.scaning = true
      this.refresh()
    } else if (data.qrcodeType === 2) {
      // this.token.setUserInfo(data)
      // this.router.navigateByUrl('/')
      this.el.afterLogin(data.code)
    }
    this.qrcodeType = data.qrcodeType
  }

  destroy() {
    this.abort()
  }
}
